<div class="container-fluid">
  <form [formGroup]=identityForm>
    <div class="row">
      <div class="col-4 col-sm form-group">
        <label class="" for="identityType">
          {{ 'IDENTITYTYPE' | translate }}
        </label>
        <select class="form-control" #t id="identityType" [ngClass]="{'form-control-sm':smallInput}"
          (change)="onIdentitySelected(t.value)" formControlName="identityType" tabindex="10">
          <option value="0"></option>
          <option *ngFor="let type of identityTypes" [value]="type.code">
            {{translate.currentLang == 'ar'? type.nameAr: type.nameEn}}
          </option>
        </select>
      </div>

      <div class="col-4 col-sm form-group" style="height: 64px;padding: 0;">

        <label> {{'NationalValue' | translate}}</label>
        <div style="background: none !important;">
          <input class="form-control" *ngIf="disableIdentity==true" formControlName="valueFormated"
            [ngClass]="{'text-danger':invaildvalue , 'text-success':!invaildvalue ,'form-control-sm':smallInput }"
            style="position:absolute;direction:ltr;" />
          <input class="form-control" *ngIf="disableIdentity==false && identityType == 1"
            formControlName="valueFormated"
            [ngClass]="{'text-danger':invaildvalue , 'text-success':!invaildvalue ,'form-control-sm':smallInput }"
            style="position:absolute;direction:ltr;" disabled />
          <!-- <input class="form-control" value="0000000-00-00-00-0" [ngClass]="{'form-control-sm':smallInput}"   style="position:absolute;color: #752a42;"   disabled /> -->
          <input class="form-control" style="background: none!important;  position: absolute;z-index:10"
            [ngClass]="{'form-control-sm':smallInput}" formControlName="identityValue" [identity]="identityType"
            (keyup)="onIdentityKeyup($event)" tabindex="11">
        </div>
        <small class="text-danger" *ngIf="invalidMessage.length > 0">{{invalidMessage}}</small>
      </div>
      <div class="col-4 col-sm form-group" *ngIf="!Companion">
        <div class="form-group">
          <label>{{'PASSPORT' | translate}}</label>
          <input class="form-control form-control-sm" type="text" formControlName="passportNo" />
        </div>
      </div>
    </div>
  </form>
  <!-- <div *ngIf="identityForm.get('identityValue').value" style=" margin-top: -15px;"><li><a (click)="eligibilityCheck()
  "><span style="color: red;">فحص اهليه </span> <span style="color: black;">{{showText}}</span> </a> </li>
  </div> -->
</div>